/* tslint:disable */
/* eslint-disable */
/**
 * Mild Blue s.r.o. - Online Connect
 * Application allowing people to ask for admition in IKEM.
 *
 * The version of the OpenAPI document: development
 * Contact: support@mild.blue
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface FormAccessRightsDtoOut
 */
export interface FormAccessRightsDtoOut {
    /**
     * 
     * @type {string}
     * @memberof FormAccessRightsDtoOut
     */
    form: FormAccessRightsDtoOutFormEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum FormAccessRightsDtoOutFormEnum {
    PatientRegistration = 'PATIENT_REGISTRATION',
    DoctorRegistration = 'DOCTOR_REGISTRATION',
    ReceiptOrder = 'RECEIPT_ORDER'
}



